import React, { useState } from 'react';
import { Button, CircularProgress, ThemeProvider, createTheme } from '@mui/material';
import cx from 'classnames';

import useAuth from '../hooks/useAuth';

import MahavirSwami from '../assets/images/mahavirSwami.png';
import { PrayingHandsIcon } from '../assets/icons';

import styles from './SplashScreen.module.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1A3263'
    },
    secondary: {
      main: '#fff'
    }
  }
});

const SplashScreen = ({ isVisible, loading, setLoading }) => {
  const { loginWithGoogle, authError } = useAuth();
  const [loginError, setLoginError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleLoginClick = () => {
    if (loading) return;

    setLoading(true);
    setLoginError('');
    setErrorMessage('');
    loginWithGoogle().then(() => {
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      const errorCode = error.code;
      if (errorCode === 'auth/user-disabled' || errorCode === 'auth/admin-restricted-operation') {
        setLoginError('Sorry! You are not allowed to use this app, Please contact us for permission.')
      } else {
        setErrorMessage('Something went wrong, please try after some time.');
      }
    });
  };

  return (
    <div className={cx(styles.container, {[styles.visible]: isVisible})}>
      <img className={styles.logoImg} src={MahavirSwami} alt="" />
      <div className={styles.text}>Punjab Jain Sangh Indore App</div>
      <div>पंजाब जैन संघ इंदौर ऐप</div>
      <PrayingHandsIcon className={styles.prayingHandsIcon} />
      {loginError || authError ? (
        <div className={styles.LoginError}>{loginError || authError}</div>
      ) : (
        <ThemeProvider theme={theme}>
          <Button onClick={handleLoginClick} className={styles.loginBtn} variant="contained">
            {loading ? (<CircularProgress size={20} color="secondary" />) : 'Login'}
          </Button>
        </ThemeProvider>
      )}
      {errorMessage && <div className={styles.LoginError}>{errorMessage}</div> }
    </div>
  );
};

export default SplashScreen;
